import {DomainStore} from 'shared/store';
import {auth, endpoints, types} from 'main/tools';
import {makeAutoObservable} from 'mobx';

class RevieweesContainerState {
  store = new DomainStore();

  pairs;
  checkins;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.REVIEWERS.with(auth.employee.id),
      endpoints.PERFORMANCE.CYCLES
    ]);

    this.pairs = this.store._getAll(types.PERFORMANCE.CHECKIN_RELATIONS);
  }
}

export default RevieweesContainerState;
